import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=64f508ac&scoped=true&"
import script from "./LandingFooter.vue?vue&type=script&lang=ts&"
export * from "./LandingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=64f508ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f508ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('64f508ac', component.options)
    } else {
      api.reload('64f508ac', component.options)
    }
    module.hot.accept("./LandingFooter.vue?vue&type=template&id=64f508ac&scoped=true&", function () {
      api.rerender('64f508ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/LandingFooter.vue"
export default component.exports